import React, { useState, useEffect } from 'react'
import {Button, Input, Select, ColorPicker, Space, Radio, message} from 'antd'
import {
    AlignLeftOutlined,
    AlignRightOutlined,
    AlignCenterOutlined, ReloadOutlined, PlusOutlined
} from '@ant-design/icons'
import useStore from '../../../stores/useStore'

const { Option } = Select

const fontOptions = [
    'Arial',
    'Times New Roman',
    'Courier New',
    'Georgia',
    'Verdana',
    'Impact',
    'Comic Sans MS',
]

const TextBlocksControl = () => {
    const {
        textBlocks,
        selectedBlockId,
        addTextBlock,
        updateTextBlock,
        selectTextBlock,
        clearSelection
    } = useStore()

    const selectedBlock = textBlocks.find(block => block.id === selectedBlockId)

    const [text, setText] = useState('')
    const [color, setColor] = useState('#000000')
    const [fontSize, setFontSize] = useState(16)
    const [fontFamily, setFontFamily] = useState('Arial')
    const [fontWeight, setFontWeightStyle] = useState('normal')
    const [textAlign, setTextAlign] = useState('left')
    const [width, setWidth] = useState('auto')
    const [height, setHeight] = useState('auto')
    const [key, setKey] = useState('')

    useEffect(() => {
        if (selectedBlock) {
            setText(selectedBlock.text || '')
            setColor(selectedBlock.color || '#000000')
            setFontSize(selectedBlock.fontSize || 16)
            setFontFamily(selectedBlock.fontFamily || 'Arial')
            setTextAlign(selectedBlock.textAlign || 'left')
            setFontWeightStyle(selectedBlock.fontWeight || 'normal')
            setWidth(selectedBlock.width || 'auto')
            setHeight(selectedBlock.height || 'auto')
            setKey(selectedBlock.key || '')
        } else {
            resetForm()
        }
    }, [selectedBlockId, selectedBlock])

    const resetForm = () => {
        setText('')
        setColor('#000000')
        setFontSize(16)
        setFontFamily('Arial')
        setTextAlign('left')
        setFontWeightStyle('normal')
        setWidth('auto')
        setHeight('auto')
        setKey('')
    }

    const handleAddText = () => {
        if (!text.trim()) {
            message.warning('Введите текст')
            return
        }

        // if (!key.trim()) {
        //     message.warning('Укажите ключ для связи с CSV данными')
        //     return
        // }

        addTextBlock({
            id: Date.now(),
            text,
            color,
            fontSize,
            fontFamily,
            fontWeight,
            textAlign,
            x: 50,
            y: 50,
            width,
            height,
            key: key.trim()
        })

        resetForm()
    }

    const handleUpdateText = () => {
        if (!selectedBlockId) return

        updateTextBlock(selectedBlockId, {
            text,
            color,
            fontSize,
            fontFamily,
            fontWeight,
            textAlign,
            width,
            height,
            key: key.trim()
        })
    }

    const handleDeselect = () => {
        clearSelection()
        resetForm()
    }

    return (
        <Space direction="vertical" style={{ width: '100%' }} className="text-blocks-control">
            {selectedBlock ? (
                <h3>Редактирование блока</h3>
            ) : (
                <h3>Создание нового блока</h3>
            )}

            <div style={{ marginBottom: 8 }} aria-label="key">
                <div style={{ marginBottom: 4, fontWeight: 'bold' }}>Ключ для подстановки данных:</div>
                <Input
                    value={key}
                    onChange={(e) => setKey(e.target.value)}
                    placeholder="Например: name"
                    style={{ marginBottom: 8 }}
                />
                <div style={{ fontSize: 12, color: '#666' }}>
                    Этот ключ должен совпадать с названием колонки в CSV файле
                </div>
            </div>

            <div style={{ marginBottom: 8 }} aria-label="text">
                <div style={{ marginBottom: 4, fontWeight: 'bold' }}>Текст (с плейсхолдерами):</div>
                <Input
                    value={text}
                    onChange={(e) => setText(e.target.value)}
                    placeholder={`Например: Привет, {name}!`}
                />
                <div style={{ fontSize: 12, color: '#666', marginTop: 4 }}>
                    Используйте {'{ключ}'} для подстановки данных из CSV
                </div>
            </div>

            <div style={{ marginBottom: 8 }}>
                <div style={{ marginBottom: 4, fontWeight: 'bold' }}>Цвет текста:</div>
                <ColorPicker
                    value={color}
                    onChange={(color) => setColor(color.toHexString())}
                    style={{ marginBottom: 8 }}
                />
            </div>

            <div style={{ marginBottom: 8 }}>
                <div style={{ marginBottom: 4, fontWeight: 'bold' }}>Размер шрифта:</div>
                <Input
                    type="number"
                    value={fontSize}
                    onChange={(e) => setFontSize(Number(e.target.value))}
                    placeholder="Размер шрифта"
                />
            </div>

            <div style={{ marginBottom: 8 }}>
                <div style={{ marginBottom: 4, fontWeight: 'bold' }}>Шрифт:</div>
                <Select
                    value={fontFamily}
                    onChange={setFontFamily}
                    style={{ width: '100%' }}
                >
                    {fontOptions.map(font => (
                        <Option key={font} value={font}>{font}</Option>
                    ))}
                </Select>
            </div>

            <div style={{ marginBottom: 8 }}>
                <div style={{ marginBottom: 4, fontWeight: 'bold' }}>Начертание:</div>
                <Select
                    value={fontWeight}
                    onChange={setFontWeightStyle}
                    style={{ width: '100%' }}
                >
                    <Option value="normal">Обычный</Option>
                    <Option value="bold">Жирный</Option>
                    <Option value="italic">Курсив</Option>
                </Select>
            </div>

            <div style={{ marginBottom: 8 }}>
                <div style={{ marginBottom: 4, fontWeight: 'bold' }}>Выравнивание:</div>
                <Radio.Group
                    value={textAlign}
                    onChange={(e) => setTextAlign(e.target.value)}
                    buttonStyle="solid"
                    style={{ width: '100%', display: 'flex' }}
                >
                    <Radio.Button value="left" style={{ flex: 1, display: 'flex', justifyContent: 'center' }}>
                        <AlignLeftOutlined />
                    </Radio.Button>
                    <Radio.Button value="center" style={{ flex: 1, display: 'flex', justifyContent: 'center' }}>
                        <AlignCenterOutlined />
                    </Radio.Button>
                    <Radio.Button value="right" style={{ flex: 1, display: 'flex', justifyContent: 'center' }}>
                        <AlignRightOutlined />
                    </Radio.Button>
                </Radio.Group>
            </div>

            <div style={{ marginBottom: 8 }} hidden>
                <div style={{ marginBottom: 4, fontWeight: 'bold' }}>Размеры блока:</div>
                <Space style={{ width: '100%', justifyContent: 'space-between' }}>
                    <Input
                        value={width}
                        onChange={(e) => setWidth(e.target.value === 'auto' ? 'auto' : Number(e.target.value))}
                        placeholder="Ширина"
                        addonBefore="Ш:"
                        style={{ width: '48%' }}
                    />
                    <Input
                        value={height}
                        onChange={(e) => setHeight(e.target.value === 'auto' ? 'auto' : Number(e.target.value))}
                        placeholder="Высота"
                        addonBefore="В:"
                        style={{ width: '48%' }}
                    />
                </Space>
            </div>

            <Space direction="vertical" style={{ width: '100%' }} className="commit-block">
                {selectedBlock ? (
                    <>
                        <Button type="primary" onClick={handleUpdateText} block>
                            <ReloadOutlined /> Обновить блок
                        </Button>
                        <Button type="default" onClick={handleDeselect} block>
                            <PlusOutlined /> Создать новый блок
                        </Button>
                    </>
                ) : (
                    <Button type="primary" onClick={handleAddText} block>
                        <PlusOutlined /> Добавить текстовый блок
                    </Button>
                )}
            </Space>

            {textBlocks.length > 0 && (
                <div style={{ marginTop: 16, padding: 12, background: '#f6ffed', borderRadius: 4 }}>
                    <div style={{ fontWeight: 'bold', marginBottom: 8 }}>Пример использования:</div>
                    <div style={{ fontSize: 12 }}>
                        1. Укажите ключ (например: "name")<br/>
                        2. В тексте используйте {'{name}'}<br/>
                        3. В CSV должна быть колонка "name"<br/>
                        4. При экспорте данные из CSV подставятся в текст
                    </div>
                </div>
            )}
        </Space>
    )
}

export default TextBlocksControl